// Parse "YYYY-MM-DDTHH:mm:ss" without UTC shift
export function parseLocalDate(str) {
  const [date, time = "00:00:00"] = (str || "").split("T");
  const [y, m, d] = date.split("-").map(Number);
  const [hh, mm] = time.split(":").map(Number);
  return new Date(y, m - 1, d, hh, mm);
}
